export function resolveStateAwareNumber(
  raw: unknown,
  selectedStateCode: string | undefined,
  fallback = 0,
): number {
  if (raw && typeof raw === "object" && !Array.isArray(raw)) {
    const value = (raw as Record<string, unknown>)[selectedStateCode || ""];
    return typeof value === "number" ? value : fallback;
  }

  return typeof raw === "number" ? raw : fallback;
}
